import { render, staticRenderFns } from "./edit-product-brands.modal.vue?vue&type=template&id=4448aa50&scoped=true&"
import script from "./edit-product-brands.modal.vue?vue&type=script&lang=js&"
export * from "./edit-product-brands.modal.vue?vue&type=script&lang=js&"
import style0 from "./edit-product-brands.modal.vue?vue&type=style&index=0&id=4448aa50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4448aa50",
  null
  
)

export default component.exports